const o = () => {
};
export {
  o as n
};
//# sourceMappingURL=noop-ClDc6zv4.js.map
